// extracted by mini-css-extract-plugin
export var categoryProduct = "j_ck";
export var categoryProductImg = "j_cl";
export var categoryProductImgColors = "j_cv";
export var categoryProductName = "j_cm";
export var categoryProductOrigin = "j_cn";
export var categoryProductPriceCn = "j_cq";
export var categoryProductPriceEn = "j_cr";
export var categoryProductTag = "j_cs";
export var categoryProductTagLine = "j_cw";